var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _c(
      "div",
      { ref: "items", class: _vm.$style.tabsBar, style: _vm.tabsBarStyle },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hideSlider && _vm.selectedValue >= 0,
                expression: "!hideSlider && selectedValue >= 0",
              },
            ],
            class: _vm.$style.sliderWrapper,
            style: _vm.sliderWrapperStyle,
            attrs: { "data-testid": "slider" },
          },
          [_c("div", { class: _vm.$style.slider })]
        ),
        _vm._v(" "),
        _c(
          "NsTabsWrapper",
          {
            attrs: { selected: _vm.selectedValue, "use-hover": _vm.useHover },
            on: { select: _vm.handleSelect },
          },
          [_vm._t("default")],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }